import { scrollToId, ASSETS, COMPANY } from "../lib/site";

export const Logo = ({ className = "", size = "h-9" }) => (
  <a
    href="#inicio"
    onClick={(e) => {
      e.preventDefault();
      scrollToId("#inicio");
    }}
    data-testid="logo-home-link"
    className={`inline-flex items-center ${className}`}
    aria-label={`${COMPANY.name} - Inicio`}
  >
    <img
      src={ASSETS.logo}
      alt="GLG Technology"
      className={`${size} w-auto object-contain`}
      draggable="false"
    />
  </a>
);
